"use strict"; // Copyright (c) 2018-2020 WalletLink.org <https://www.walletlink.org/>
// Copyright (c) 2018-2020 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0

var _regeneratorRuntime = require("E:\\Blockchain\\prnts_main_repo\\PrntPlace-main\\client\\node_modules\\@babel\\runtime/regenerator");

var _asyncToGenerator = require("E:\\Blockchain\\prnts_main_repo\\PrntPlace-main\\client\\node_modules\\@babel\\runtime/helpers/asyncToGenerator");

var _classCallCheck = require("E:\\Blockchain\\prnts_main_repo\\PrntPlace-main\\client\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("E:\\Blockchain\\prnts_main_repo\\PrntPlace-main\\client\\node_modules\\@babel\\runtime/helpers/createClass");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WalletLinkProvider = void 0;

var bn_js_1 = __importDefault(require("bn.js"));

var util_1 = require("../util");

var eth_eip712_util_1 = __importDefault(require("../vendor-js/eth-eip712-util"));

var FilterPolyfill_1 = require("./FilterPolyfill");

var JSONRPC_1 = require("./JSONRPC");

var Web3Provider_1 = require("./Web3Provider");

var LOCAL_STORAGE_ADDRESSES_KEY = "Addresses";

var WalletLinkProvider =
/*#__PURE__*/
function () {
  function WalletLinkProvider(options) {
    _classCallCheck(this, WalletLinkProvider);

    this._filterPolyfill = new FilterPolyfill_1.FilterPolyfill(this);
    this._addresses = [];
    this._send = this.send;
    this._sendAsync = this.sendAsync;

    if (!options.relay) {
      throw new Error("realy must be provided");
    }

    if (!options.jsonRpcUrl) {
      throw new Error("jsonRpcUrl must be provided");
    }

    this._relay = options.relay;
    this._chainId = util_1.ensureIntNumber(options.chainId || 1);
    this._jsonRpcUrl = options.jsonRpcUrl;

    var cahedAddresses = this._relay.getStorageItem(LOCAL_STORAGE_ADDRESSES_KEY);

    if (cahedAddresses) {
      var addresses = cahedAddresses.split(" ");

      if (addresses[0] !== "") {
        this._addresses = addresses;
      }
    }
  }

  _createClass(WalletLinkProvider, [{
    key: "isConnected",
    value: function isConnected() {
      return true;
    }
  }, {
    key: "enable",
    value: function () {
      var _enable = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this._addresses.length > 0)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", this._addresses);

              case 2:
                _context.next = 4;
                return this._send(JSONRPC_1.JSONRPCMethod.eth_requestAccounts);

              case 4:
                return _context.abrupt("return", _context.sent);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function enable() {
        return _enable.apply(this, arguments);
      }

      return enable;
    }()
  }, {
    key: "close",
    value: function close() {
      this._relay.resetAndReload();
    }
  }, {
    key: "send",
    value: function send(requestOrMethod, callbackOrParams) {
      var _this = this;

      // send<T>(method, params): Promise<T>
      if (typeof requestOrMethod === "string") {
        var method = requestOrMethod;
        var params = Array.isArray(callbackOrParams) ? callbackOrParams : callbackOrParams !== undefined ? [callbackOrParams] : [];
        var request = {
          jsonrpc: "2.0",
          id: 0,
          method: method,
          params: params
        };
        return this._sendRequestAsync(request).then(function (res) {
          return res.result;
        });
      } // send(JSONRPCRequest | JSONRPCRequest[], callback): void


      if (typeof callbackOrParams === "function") {
        var _request = requestOrMethod;
        var callback = callbackOrParams;
        return this._sendAsync(_request, callback);
      } // send(JSONRPCRequest[]): JSONRPCResponse[]


      if (Array.isArray(requestOrMethod)) {
        var requests = requestOrMethod;
        return requests.map(function (r) {
          return _this._sendRequest(r);
        });
      } // send(JSONRPCRequest): JSONRPCResponse


      var req = requestOrMethod;
      return this._sendRequest(req);
    }
  }, {
    key: "sendAsync",
    value: function sendAsync(request, callback) {
      if (typeof callback !== "function") {
        throw new Error("callback is required");
      } // send(JSONRPCRequest[], callback): void


      if (Array.isArray(request)) {
        var arrayCb = callback;

        this._sendMultipleRequestsAsync(request).then(function (responses) {
          return arrayCb(null, responses);
        }).catch(function (err) {
          return arrayCb(err, null);
        });

        return;
      } // send(JSONRPCRequest, callback): void


      var cb = callback;

      this._sendRequestAsync(request).then(function (response) {
        return cb(null, response);
      }).catch(function (err) {
        return cb(err, null);
      });
    }
  }, {
    key: "scanQRCode",
    value: function () {
      var _scanQRCode = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(match) {
        var res;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this._relay.scanQRCode(util_1.ensureRegExpString(match));

              case 2:
                res = _context2.sent;

                if (!(typeof res.result !== "string")) {
                  _context2.next = 5;
                  break;
                }

                throw new Error("result was not a string");

              case 5:
                return _context2.abrupt("return", res.result);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function scanQRCode(_x) {
        return _scanQRCode.apply(this, arguments);
      }

      return scanQRCode;
    }()
  }, {
    key: "arbitraryRequest",
    value: function () {
      var _arbitraryRequest = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(data) {
        var res;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this._relay.arbitraryRequest(data);

              case 2:
                res = _context3.sent;

                if (!(typeof res.result !== "string")) {
                  _context3.next = 5;
                  break;
                }

                throw new Error("result was not a string");

              case 5:
                return _context3.abrupt("return", res.result);

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function arbitraryRequest(_x2) {
        return _arbitraryRequest.apply(this, arguments);
      }

      return arbitraryRequest;
    }()
  }, {
    key: "supportsSubscriptions",
    value: function supportsSubscriptions() {
      return false;
    }
  }, {
    key: "subscribe",
    value: function subscribe() {
      throw new Error("Subscriptions are not supported");
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe() {
      throw new Error("Subscriptions are not supported");
    }
  }, {
    key: "disconnect",
    value: function disconnect() {
      return true;
    }
  }, {
    key: "_sendRequest",
    value: function _sendRequest(request) {
      var response = {
        jsonrpc: "2.0",
        id: request.id
      };
      var method = request.method;
      response.result = this._handleSynchronousMethods(request);

      if (response.result === undefined) {
        throw new Error("WalletLink does not support calling ".concat(method, " synchronously without ") + "a callback. Please provide a callback parameter to call ".concat(method, " ") + "asynchronously.");
      }

      return response;
    }
  }, {
    key: "_setAddresses",
    value: function _setAddresses(addresses) {
      if (!Array.isArray(addresses)) {
        throw new Error("addresses is not an array");
      }

      this._addresses = addresses.map(function (address) {
        return util_1.ensureAddressString(address);
      });

      this._relay.setStorageItem(LOCAL_STORAGE_ADDRESSES_KEY, addresses.join(" "));

      window.dispatchEvent(new CustomEvent("walletlink:addresses", {
        detail: this._addresses
      }));
    }
  }, {
    key: "_sendRequestAsync",
    value: function _sendRequestAsync(request) {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        try {
          var syncResult = _this2._handleSynchronousMethods(request);

          if (syncResult !== undefined) {
            return resolve({
              jsonrpc: "2.0",
              id: request.id,
              result: syncResult
            });
          }

          var filterPromise = _this2._handleAsynchronousFilterMethods(request);

          if (filterPromise !== undefined) {
            filterPromise.then(function (res) {
              return resolve(Object.assign(Object.assign({}, res), {
                id: request.id
              }));
            }).catch(function (err) {
              return reject(err);
            });
            return;
          }
        } catch (err) {
          return reject(err);
        }

        _this2._handleAsynchronousMethods(request).then(function (res) {
          return resolve(Object.assign(Object.assign({}, res), {
            id: request.id
          }));
        }).catch(function (err) {
          return reject(err);
        });
      });
    }
  }, {
    key: "_sendMultipleRequestsAsync",
    value: function _sendMultipleRequestsAsync(requests) {
      var _this3 = this;

      return Promise.all(requests.map(function (r) {
        return _this3._sendRequestAsync(r);
      }));
    }
  }, {
    key: "_handleSynchronousMethods",
    value: function _handleSynchronousMethods(request) {
      var method = request.method;
      var params = request.params || [];

      switch (method) {
        case JSONRPC_1.JSONRPCMethod.eth_accounts:
          return this._eth_accounts();

        case JSONRPC_1.JSONRPCMethod.eth_coinbase:
          return this._eth_coinbase();

        case JSONRPC_1.JSONRPCMethod.eth_uninstallFilter:
          return this._eth_uninstallFilter(params);

        case JSONRPC_1.JSONRPCMethod.net_version:
          return this._net_version();

        default:
          return undefined;
      }
    }
  }, {
    key: "_handleAsynchronousMethods",
    value: function _handleAsynchronousMethods(request) {
      var method = request.method;
      var params = request.params || [];

      switch (method) {
        case JSONRPC_1.JSONRPCMethod.eth_requestAccounts:
          return this._eth_requestAccounts();

        case JSONRPC_1.JSONRPCMethod.eth_sign:
          return this._eth_sign(params);

        case JSONRPC_1.JSONRPCMethod.eth_ecRecover:
          return this._eth_ecRecover(params);

        case JSONRPC_1.JSONRPCMethod.personal_sign:
          return this._personal_sign(params);

        case JSONRPC_1.JSONRPCMethod.personal_ecRecover:
          return this._personal_ecRecover(params);

        case JSONRPC_1.JSONRPCMethod.eth_signTransaction:
          return this._eth_signTransaction(params);

        case JSONRPC_1.JSONRPCMethod.eth_sendRawTransaction:
          return this._eth_sendRawTransaction(params);

        case JSONRPC_1.JSONRPCMethod.eth_sendTransaction:
          return this._eth_sendTransaction(params);

        case JSONRPC_1.JSONRPCMethod.eth_signTypedData_v1:
          return this._eth_signTypedData_v1(params);

        case JSONRPC_1.JSONRPCMethod.eth_signTypedData_v2:
          return this._throwUnsupportedMethodError();

        case JSONRPC_1.JSONRPCMethod.eth_signTypedData_v3:
          return this._eth_signTypedData_v3(params);

        case JSONRPC_1.JSONRPCMethod.eth_signTypedData_v4:
        case JSONRPC_1.JSONRPCMethod.eth_signTypedData:
          return this._eth_signTypedData_v4(params);

        case JSONRPC_1.JSONRPCMethod.walletlink_arbitrary:
          return this._walletlink_arbitrary(params);
      }

      return window.fetch(this._jsonRpcUrl, {
        method: "POST",
        body: JSON.stringify(request),
        mode: "cors",
        headers: {
          "Content-Type": "application/json"
        }
      }).then(function (res) {
        return res.json();
      }).then(function (json) {
        if (!json) {
          throw new Web3Provider_1.ProviderError("unexpected response");
        }

        var response = json;
        var error = response.error;

        if (error) {
          throw new Web3Provider_1.ProviderError(error.message || "RPC Error", error.code, error.data);
        }

        return response;
      });
    }
  }, {
    key: "_handleAsynchronousFilterMethods",
    value: function _handleAsynchronousFilterMethods(request) {
      var method = request.method;
      var params = request.params || [];

      switch (method) {
        case JSONRPC_1.JSONRPCMethod.eth_newFilter:
          return this._eth_newFilter(params);

        case JSONRPC_1.JSONRPCMethod.eth_newBlockFilter:
          return this._eth_newBlockFilter();

        case JSONRPC_1.JSONRPCMethod.eth_newPendingTransactionFilter:
          return this._eth_newPendingTransactionFilter();

        case JSONRPC_1.JSONRPCMethod.eth_getFilterChanges:
          return this._eth_getFilterChanges(params);

        case JSONRPC_1.JSONRPCMethod.eth_getFilterLogs:
          return this._eth_getFilterLogs(params);
      }

      return undefined;
    }
  }, {
    key: "_isKnownAddress",
    value: function _isKnownAddress(addressString) {
      try {
        var address = util_1.ensureAddressString(addressString);
        return this._addresses.includes(address);
      } catch (_a) {}

      return false;
    }
  }, {
    key: "_ensureKnownAddress",
    value: function _ensureKnownAddress(addressString) {
      if (!this._isKnownAddress(addressString)) {
        throw new Error("Unknown Ethereum address");
      }
    }
  }, {
    key: "_prepareTransactionParams",
    value: function _prepareTransactionParams(tx) {
      var fromAddress = tx.from ? util_1.ensureAddressString(tx.from) : this.selectedAddress;

      if (!fromAddress) {
        throw new Error("Ethereum address is unavailable");
      }

      this._ensureKnownAddress(fromAddress);

      var toAddress = tx.to ? util_1.ensureAddressString(tx.to) : null;
      var weiValue = tx.value != null ? util_1.ensureBN(tx.value) : new bn_js_1.default(0);
      var data = tx.data ? util_1.ensureBuffer(tx.data) : Buffer.alloc(0);
      var nonce = tx.nonce != null ? util_1.ensureIntNumber(tx.nonce) : null;
      var gasPriceInWei = tx.gasPrice != null ? util_1.ensureBN(tx.gasPrice) : null;
      var gasLimit = tx.gas != null ? util_1.ensureBN(tx.gas) : null;
      var chainId = this._chainId;
      return {
        fromAddress: fromAddress,
        toAddress: toAddress,
        weiValue: weiValue,
        data: data,
        nonce: nonce,
        gasPriceInWei: gasPriceInWei,
        gasLimit: gasLimit,
        chainId: chainId
      };
    }
  }, {
    key: "_requireAuthorization",
    value: function _requireAuthorization() {
      if (this._addresses.length === 0) {
        throw new Web3Provider_1.ProviderError("Unauthorized", Web3Provider_1.ProviderErrorCode.UNAUTHORIZED);
      }
    }
  }, {
    key: "_throwUnsupportedMethodError",
    value: function _throwUnsupportedMethodError() {
      throw new Web3Provider_1.ProviderError("Unsupported method", Web3Provider_1.ProviderErrorCode.UNSUPPORTED_METHOD);
    }
  }, {
    key: "_signEthereumMessage",
    value: function () {
      var _signEthereumMessage2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(message, address, addPrefix, typedDataJson) {
        var res;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this._ensureKnownAddress(address);

                _context4.prev = 1;
                _context4.next = 4;
                return this._relay.signEthereumMessage(message, address, addPrefix, typedDataJson);

              case 4:
                res = _context4.sent;
                return _context4.abrupt("return", {
                  jsonrpc: "2.0",
                  id: 0,
                  result: res.result
                });

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4["catch"](1);

                if (!(typeof _context4.t0.message === "string" && _context4.t0.message.match(/(denied|rejected)/i))) {
                  _context4.next = 12;
                  break;
                }

                throw new Web3Provider_1.ProviderError("User denied message signature", Web3Provider_1.ProviderErrorCode.USER_DENIED_REQUEST_SIGNATURE);

              case 12:
                throw _context4.t0;

              case 13:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[1, 8]]);
      }));

      function _signEthereumMessage(_x3, _x4, _x5, _x6) {
        return _signEthereumMessage2.apply(this, arguments);
      }

      return _signEthereumMessage;
    }()
  }, {
    key: "_ethereumAddressFromSignedMessage",
    value: function () {
      var _ethereumAddressFromSignedMessage2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(message, signature, addPrefix) {
        var res;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this._relay.ethereumAddressFromSignedMessage(message, signature, addPrefix);

              case 2:
                res = _context5.sent;
                return _context5.abrupt("return", {
                  jsonrpc: "2.0",
                  id: 0,
                  result: res.result
                });

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function _ethereumAddressFromSignedMessage(_x7, _x8, _x9) {
        return _ethereumAddressFromSignedMessage2.apply(this, arguments);
      }

      return _ethereumAddressFromSignedMessage;
    }()
  }, {
    key: "_eth_accounts",
    value: function _eth_accounts() {
      return this._addresses;
    }
  }, {
    key: "_eth_coinbase",
    value: function _eth_coinbase() {
      return this.selectedAddress || null;
    }
  }, {
    key: "_net_version",
    value: function _net_version() {
      return this._chainId.toString(10);
    }
  }, {
    key: "_eth_requestAccounts",
    value: function () {
      var _eth_requestAccounts2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6() {
        var res;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!(this._addresses.length > 0)) {
                  _context6.next = 2;
                  break;
                }

                return _context6.abrupt("return", Promise.resolve({
                  jsonrpc: "2.0",
                  id: 0,
                  result: this._addresses
                }));

              case 2:
                _context6.prev = 2;
                _context6.next = 5;
                return this._relay.requestEthereumAccounts();

              case 5:
                res = _context6.sent;
                _context6.next = 13;
                break;

              case 8:
                _context6.prev = 8;
                _context6.t0 = _context6["catch"](2);

                if (!(typeof _context6.t0.message === "string" && _context6.t0.message.match(/(denied|rejected)/i))) {
                  _context6.next = 12;
                  break;
                }

                throw new Web3Provider_1.ProviderError("User denied account authorization", Web3Provider_1.ProviderErrorCode.USER_DENIED_REQUEST_ACCOUNTS);

              case 12:
                throw _context6.t0;

              case 13:
                if (res.result) {
                  _context6.next = 15;
                  break;
                }

                throw new Error("accounts received is empty");

              case 15:
                this._setAddresses(res.result);

                return _context6.abrupt("return", {
                  jsonrpc: "2.0",
                  id: 0,
                  result: this._addresses
                });

              case 17:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[2, 8]]);
      }));

      function _eth_requestAccounts() {
        return _eth_requestAccounts2.apply(this, arguments);
      }

      return _eth_requestAccounts;
    }()
  }, {
    key: "_eth_sign",
    value: function _eth_sign(params) {
      this._requireAuthorization();

      var address = util_1.ensureAddressString(params[0]);
      var message = util_1.ensureBuffer(params[1]);
      return this._signEthereumMessage(message, address, false);
    }
  }, {
    key: "_eth_ecRecover",
    value: function _eth_ecRecover(params) {
      var message = util_1.ensureBuffer(params[0]);
      var signature = util_1.ensureBuffer(params[1]);
      return this._ethereumAddressFromSignedMessage(message, signature, false);
    }
  }, {
    key: "_personal_sign",
    value: function _personal_sign(params) {
      this._requireAuthorization();

      var message = util_1.ensureBuffer(params[0]);
      var address = util_1.ensureAddressString(params[1]);
      return this._signEthereumMessage(message, address, true);
    }
  }, {
    key: "_personal_ecRecover",
    value: function _personal_ecRecover(params) {
      var message = util_1.ensureBuffer(params[0]);
      var signature = util_1.ensureBuffer(params[1]);
      return this._ethereumAddressFromSignedMessage(message, signature, true);
    }
  }, {
    key: "_eth_signTransaction",
    value: function () {
      var _eth_signTransaction2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7(params) {
        var tx, res;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                this._requireAuthorization();

                tx = this._prepareTransactionParams(params[0] || {});
                _context7.prev = 2;
                _context7.next = 5;
                return this._relay.signEthereumTransaction(tx);

              case 5:
                res = _context7.sent;
                return _context7.abrupt("return", {
                  jsonrpc: "2.0",
                  id: 0,
                  result: res.result
                });

              case 9:
                _context7.prev = 9;
                _context7.t0 = _context7["catch"](2);

                if (!(typeof _context7.t0.message === "string" && _context7.t0.message.match(/(denied|rejected)/i))) {
                  _context7.next = 13;
                  break;
                }

                throw new Web3Provider_1.ProviderError("User denied transaction signature", Web3Provider_1.ProviderErrorCode.USER_DENIED_REQUEST_SIGNATURE);

              case 13:
                throw _context7.t0;

              case 14:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[2, 9]]);
      }));

      function _eth_signTransaction(_x10) {
        return _eth_signTransaction2.apply(this, arguments);
      }

      return _eth_signTransaction;
    }()
  }, {
    key: "_eth_sendRawTransaction",
    value: function () {
      var _eth_sendRawTransaction2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8(params) {
        var signedTransaction, res;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                signedTransaction = util_1.ensureBuffer(params[0]);
                _context8.next = 3;
                return this._relay.submitEthereumTransaction(signedTransaction, this._chainId);

              case 3:
                res = _context8.sent;
                return _context8.abrupt("return", {
                  jsonrpc: "2.0",
                  id: 0,
                  result: res.result
                });

              case 5:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function _eth_sendRawTransaction(_x11) {
        return _eth_sendRawTransaction2.apply(this, arguments);
      }

      return _eth_sendRawTransaction;
    }()
  }, {
    key: "_eth_sendTransaction",
    value: function () {
      var _eth_sendTransaction2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee9(params) {
        var tx, res;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                this._requireAuthorization();

                tx = this._prepareTransactionParams(params[0] || {});
                _context9.prev = 2;
                _context9.next = 5;
                return this._relay.signAndSubmitEthereumTransaction(tx);

              case 5:
                res = _context9.sent;
                return _context9.abrupt("return", {
                  jsonrpc: "2.0",
                  id: 0,
                  result: res.result
                });

              case 9:
                _context9.prev = 9;
                _context9.t0 = _context9["catch"](2);

                if (!(typeof _context9.t0.message === "string" && _context9.t0.message.match(/(denied|rejected)/i))) {
                  _context9.next = 13;
                  break;
                }

                throw new Web3Provider_1.ProviderError("User denied transaction signature", Web3Provider_1.ProviderErrorCode.USER_DENIED_REQUEST_SIGNATURE);

              case 13:
                throw _context9.t0;

              case 14:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this, [[2, 9]]);
      }));

      function _eth_sendTransaction(_x12) {
        return _eth_sendTransaction2.apply(this, arguments);
      }

      return _eth_sendTransaction;
    }()
  }, {
    key: "_eth_signTypedData_v1",
    value: function () {
      var _eth_signTypedData_v = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee10(params) {
        var typedData, address, message, typedDataJSON;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                this._requireAuthorization();

                typedData = util_1.ensureParsedJSONObject(params[0]);
                address = util_1.ensureAddressString(params[1]);

                this._ensureKnownAddress(address);

                message = eth_eip712_util_1.default.hashForSignTypedDataLegacy({
                  data: typedData
                });
                typedDataJSON = JSON.stringify(typedData, null, 2);
                return _context10.abrupt("return", this._signEthereumMessage(message, address, false, typedDataJSON));

              case 7:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function _eth_signTypedData_v1(_x13) {
        return _eth_signTypedData_v.apply(this, arguments);
      }

      return _eth_signTypedData_v1;
    }()
  }, {
    key: "_eth_signTypedData_v3",
    value: function () {
      var _eth_signTypedData_v2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee11(params) {
        var address, typedData, message, typedDataJSON;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                this._requireAuthorization();

                address = util_1.ensureAddressString(params[0]);
                typedData = util_1.ensureParsedJSONObject(params[1]);

                this._ensureKnownAddress(address);

                message = eth_eip712_util_1.default.hashForSignTypedData_v3({
                  data: typedData
                });
                typedDataJSON = JSON.stringify(typedData, null, 2);
                return _context11.abrupt("return", this._signEthereumMessage(message, address, false, typedDataJSON));

              case 7:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function _eth_signTypedData_v3(_x14) {
        return _eth_signTypedData_v2.apply(this, arguments);
      }

      return _eth_signTypedData_v3;
    }()
  }, {
    key: "_eth_signTypedData_v4",
    value: function () {
      var _eth_signTypedData_v5 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee12(params) {
        var address, typedData, message, typedDataJSON;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                this._requireAuthorization();

                address = util_1.ensureAddressString(params[0]);
                typedData = util_1.ensureParsedJSONObject(params[1]);

                this._ensureKnownAddress(address);

                message = eth_eip712_util_1.default.hashForSignTypedData_v4({
                  data: typedData
                });
                typedDataJSON = JSON.stringify(typedData, null, 2);
                return _context12.abrupt("return", this._signEthereumMessage(message, address, false, typedDataJSON));

              case 7:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function _eth_signTypedData_v4(_x15) {
        return _eth_signTypedData_v5.apply(this, arguments);
      }

      return _eth_signTypedData_v4;
    }()
  }, {
    key: "_walletlink_arbitrary",
    value: function () {
      var _walletlink_arbitrary2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee13(params) {
        var data, result;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                data = params[0];

                if (!(typeof data !== "string")) {
                  _context13.next = 3;
                  break;
                }

                throw new Error("parameter must be a string");

              case 3:
                _context13.next = 5;
                return this.arbitraryRequest(data);

              case 5:
                result = _context13.sent;
                return _context13.abrupt("return", {
                  jsonrpc: "2.0",
                  id: 0,
                  result: result
                });

              case 7:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function _walletlink_arbitrary(_x16) {
        return _walletlink_arbitrary2.apply(this, arguments);
      }

      return _walletlink_arbitrary;
    }()
  }, {
    key: "_eth_uninstallFilter",
    value: function _eth_uninstallFilter(params) {
      var filterId = util_1.ensureHexString(params[0]);
      return this._filterPolyfill.uninstallFilter(filterId);
    }
  }, {
    key: "_eth_newFilter",
    value: function () {
      var _eth_newFilter2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee14(params) {
        var param, filterId;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                param = params[0];
                _context14.next = 3;
                return this._filterPolyfill.newFilter(param);

              case 3:
                filterId = _context14.sent;
                return _context14.abrupt("return", {
                  jsonrpc: "2.0",
                  id: 0,
                  result: filterId
                });

              case 5:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function _eth_newFilter(_x17) {
        return _eth_newFilter2.apply(this, arguments);
      }

      return _eth_newFilter;
    }()
  }, {
    key: "_eth_newBlockFilter",
    value: function () {
      var _eth_newBlockFilter2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee15() {
        var filterId;
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.next = 2;
                return this._filterPolyfill.newBlockFilter();

              case 2:
                filterId = _context15.sent;
                return _context15.abrupt("return", {
                  jsonrpc: "2.0",
                  id: 0,
                  result: filterId
                });

              case 4:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function _eth_newBlockFilter() {
        return _eth_newBlockFilter2.apply(this, arguments);
      }

      return _eth_newBlockFilter;
    }()
  }, {
    key: "_eth_newPendingTransactionFilter",
    value: function () {
      var _eth_newPendingTransactionFilter2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee16() {
        var filterId;
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.next = 2;
                return this._filterPolyfill.newPendingTransactionFilter();

              case 2:
                filterId = _context16.sent;
                return _context16.abrupt("return", {
                  jsonrpc: "2.0",
                  id: 0,
                  result: filterId
                });

              case 4:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function _eth_newPendingTransactionFilter() {
        return _eth_newPendingTransactionFilter2.apply(this, arguments);
      }

      return _eth_newPendingTransactionFilter;
    }()
  }, {
    key: "_eth_getFilterChanges",
    value: function _eth_getFilterChanges(params) {
      var filterId = util_1.ensureHexString(params[0]);
      return this._filterPolyfill.getFilterChanges(filterId);
    }
  }, {
    key: "_eth_getFilterLogs",
    value: function _eth_getFilterLogs(params) {
      var filterId = util_1.ensureHexString(params[0]);
      return this._filterPolyfill.getFilterLogs(filterId);
    }
  }, {
    key: "selectedAddress",
    get: function get() {
      return this._addresses[0] || undefined;
    }
  }, {
    key: "networkVersion",
    get: function get() {
      return this._chainId.toString(10);
    }
  }, {
    key: "isWalletLink",
    get: function get() {
      return true;
    }
  }, {
    key: "host",
    get: function get() {
      return this._jsonRpcUrl;
    }
  }, {
    key: "connected",
    get: function get() {
      return true;
    }
  }]);

  return WalletLinkProvider;
}();

exports.WalletLinkProvider = WalletLinkProvider;